import {
  Icon,
  Link,
  Spinner,
  SpinnerSize,
  TooltipHost,
} from 'office-ui-fabric-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  COMMENTSTATUS_APPROVED,
  COMMENTSTATUS_NOTAPPROVED,
} from '../../../../../../constants/api';
import { getAttr } from '../../../../../../features/helpers/apiHelpers';
import { translateCommentStatus } from '../../../../../../utilities/mapperFunctions';

const CommentFooter = ({
  showFooter,
  onApproveComment,
  onDeclineComment,
  onReplyToComment,
  commentStatus,
  containsSensitiveInformation,
  showSpinner,
  isCommentReplyEdit,
}) => {
  const { t: translator } = useTranslation();

  const status = getAttr(commentStatus, 'status');

  const disableApproveComment = status === COMMENTSTATUS_APPROVED;
  const disableDeclineComment = status === COMMENTSTATUS_NOTAPPROVED;

  const sensitiveInfoTooltipText = containsSensitiveInformation
    ? translator('pages.hearingDetails.commentIsSensitiveTooltip')
    : translator('pages.hearingDetails.commentIsNotSensitiveTooltip');

  const replyToCommentText = isCommentReplyEdit
    ? translator('pages.hearingDetails.commentEditReply')
    : translator('pages.hearingDetails.commentCreateReply');

  const sensitiveInfoIconName = containsSensitiveInformation
    ? 'EmojiDisappointed'
    : 'Emoji2';

  if (!showFooter) {
    return null;
  }

  if (showSpinner) {
    return (
      <div>
        <hr className="create-hearing-header-hr" />
        <Spinner size={SpinnerSize.large} />
      </div>
    );
  }

  return (
    <div className="review-comment">
      <hr className="create-hearing-header-hr" />
      <div>
        <TooltipHost content={sensitiveInfoTooltipText}>
          <Icon
            iconName={sensitiveInfoIconName}
            styles={containsSensitiveInfoIconStyle(
              containsSensitiveInformation,
            )}
          />
        </TooltipHost>
      </div>
      <div>
        <p>{`${translator(
          'pages.hearingDetails.commentCurrentStatus',
        )}: ${translateCommentStatus(translator)(commentStatus)}`}</p>
        <Link
          onClick={onDeclineComment}
          disabled={disableDeclineComment}
          styles={declineStyles}
        >
          {translator('pages.hearingDetails.commentDecline')}
        </Link>
        <Link
          onClick={onApproveComment}
          styles={approveStyles}
          disabled={disableApproveComment}
        >
          {translator('pages.hearingDetails.commentApprove')}
        </Link>
        <Link onClick={onReplyToComment}>{replyToCommentText}</Link>
      </div>
    </div>
  );
};

const containsSensitiveInfoIconStyle = (containsSensitiveInfo) => ({
  root: {
    color: containsSensitiveInfo ? '#d13438' : '#107c10',
  },
});

const approveStyles = {
  root: {
    ':not(.is-disabled)': {
      color: '#107c10',
    },
  },
};

const declineStyles = {
  root: {
    ':not(.is-disabled)': {
      color: '#d13438',
    },
  },
};

export { CommentFooter };
